<template>
  <sticky-header-layout>
    <template #header>
      <div class="action-container">
        <div class="pagination-container">
        </div>
        <div class="button-container">
          <el-button
            :disabled="isLoading"
            icon="el-icon-close"
            size="mini"
            @click="resetFiliter"
          >{{ $t('button.resetFilter') }}</el-button>
          <el-button
            :disabled="isLoading"
            type="primary"
            icon="el-icon-search"
            size="mini"
            @click="handleSearch"
          >{{ $t('button.search') }}</el-button>
        </div>
      </div>
      <div class="filter-container">
        <div class="filter-item">
          <label-wrapper label="Merchant">
            <el-select
              v-model="filter.merchant_id"
              :disabled="isLoading"
              :loading="isFetchingMerchants"
              filterable
            >
              <el-option
                v-for="item in merchants"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </label-wrapper>
        </div>
        <div class="filter-item">
          <label-wrapper label="Currency">
            <el-select
              v-model="filter.currency_id"
              :disabled="isLoading"
              :loading="isFetchingCurrency"
              filterable
            >
              <el-option
                v-for="item in currencyList"
                :key="item.code"
                :label="item.code"
                :value="item.code"
              />
            </el-select>
          </label-wrapper>
        </div>
        <div class="filter-item">
          <label-wrapper label="Country">
            <el-select
              v-model="filter.country_id"
              :disabled="isLoading"
              :loading="isFetchingCountry"
              filterable
            >
              <el-option
                v-for="item in countryList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </label-wrapper>
        </div>
        <div class="filter-item">
          <label-wrapper label="GX Platform">
            <el-select
              v-model="filter.gx_platform"
              :disabled="isLoading"
              filterable
            >
              <el-option
                v-for="item in gxPlatform"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </label-wrapper>
        </div>
        <div class="filter-item">
          <label-wrapper label="Platform">
            <el-select
              v-model="filter.platform"
              :disabled="isLoading"
              filterable
            >
              <el-option
                v-for="item in platformList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </label-wrapper>
        </div>
        <div class="filter-item">
          <label-wrapper label="Order Number">
            <el-input
              :disabled="isLoading"
              v-model="filter.order_number"
              clearable
            />
          </label-wrapper>
        </div>

        <div class="filter-item">
          <label-wrapper :label="$t('mpOrder.dateRange')">
            <el-date-picker
              v-model="dateValue"
              format="yyyy/MM/dd"
              type="daterange"
              align="right"
              start-placeholder="Start Date"
              end-placeholder="End Date"
              default-value="2021-01-01">
            </el-date-picker>
          </label-wrapper>
        </div>
      </div>
    </template>

    <el-table
      :data="tableData"
      v-loading="isLoading"
      stripe
      border
      style="width: 100%">
      <el-table-column
        prop="avgBasketAmount"
        label="Average Basket Amount"
        width="180">
      </el-table-column>
      <el-table-column
        prop="avgBasketSize"
        label="Average Basket Size"
        width="180">
      </el-table-column>
      <el-table-column
        prop="topStoreName"
        label="Top Store Name"
        width="180">
      </el-table-column>
      <el-table-column
        prop="topStoreSales"
        label="Top Store Sales"
        width="180">
      </el-table-column>
      <el-table-column
        prop="totalOrders"
        label="Total Orders"
        width="180">
      </el-table-column>
      <el-table-column
        prop="totalProducts"
        label="Total Products"
        width="180">
      </el-table-column>
      <el-table-column
        prop="totalProductsAmount"
        label="Total Products Amount"
        width="180">
      </el-table-column>
      <el-table-column
        prop="totalRefundProduct"
        label="Total Refund Product Amount"
        width="180">
      </el-table-column>
      <el-table-column
        prop="totalRefundShipping"
        label="Total Refund Shipping Amount"
        width="180">
      </el-table-column>
      <el-table-column
        prop="totalShipping"
        label="Total Shipping Amount"
        width="180">
      </el-table-column>

    </el-table>

  </sticky-header-layout>
</template>

<script>
import format from 'date-fns/format'

import LabelWrapper from '../../components/form/LabelWrapper.vue'

import MarketplaceService from '../../api/marketplace'
import useTablePaging from '../../mixins/useTablePaging'
import { getUTCDate } from '../../utils/helper'

export default {
  name: 'OrdersSummary',
  components: {
    LabelWrapper,
  },
  mixins: [useTablePaging],
  data() {
    return {
      filter: {
        platform: '',
        start_date: '',
        end_date: '',
        payment_currency: '',
        gx_platform: '',
        order_number: '',
        country_id: '',
        merchant_id: '',
      },

      isLoading: false,

      isFetchingMerchants: false,
      isFetchingCountry: false,
      isFetchingCurrency: false,
      merchants: [],
      countryList: [],
      currencyList: [],
      gxPlatform: [
        {name: 'Goxip', id: 'gx'},
        {name: 'RewardSnap', id: 'rs'},
      ],
      platformList: [
        {name: 'ios', id: 'ios'},
        {name: 'Android', id: 'android'},
        {name: 'Web', id: 'web'},
      ],

      dateValue: '',
      tableData: [{
            avgBasketAmount: '',
            avgBasketSize: '',
            topStoreName: '',
            topStoreSales: '',
            totalOrders: '',
            totalProducts: '',
            totalProductsAmount: '',
            totalRefundProduct: '',
            totalRefundShipping: '',
            totalShipping: '',
          }],
    }
  },
  async mounted() {
    this.fetchMerchants()
    this.fetchCountryList()
    this.fetchCurrencyList()
    // const res = await MarketplaceService.getOrderSummary({platform: 'goxip'})
    // console.log(res)
  },
  methods: {
    async fetchMerchants() {
      this.isFetchingMerchants = true
      try {
        const response = await MarketplaceService.getMerchantList()
        this.merchants = [
          { id: '', name: this.$t('mpOrder.all') },
          ...response.data,
        ]
      } finally {
        this.isFetchingMerchants = false
      }
    },
    async fetchCountryList() {
      this.isFetchingCountry = true
      try {
        const res = await MarketplaceService.getCountryList()
        this.countryList = [
          {id: '', name: this.$t('mpOrder.all')},
          ...res.data,
        ]
      } catch {
        console.log(e)
      } finally {
        this.isFetchingCountry = false
      }
    },
    async fetchCurrencyList() {
      this.isFetchingCurrency = true
      try {
        const res = await MarketplaceService.getCurrencyList()

        this.currencyList = [
          {code: ''},
          ...res.data,
        ]
      } catch {
        console.log(e)
      } finally {
        this.isFetchingCurrency = false
      }
    },
    async getList() {
      this.isLoading = true
      this.filter.start_date = format(getUTCDate(this.dateValue[0]), 'yyyy-MM-dd')
      this.filter.end_date = format(getUTCDate(this.dateValue[1]), 'yyyy-MM-dd')
      try {
        const res = await MarketplaceService.getOrderSummary({
          platform: this.filter.platform,
          start_date: this.filter.start_date,
          end_date: this.filter.end_date,
          merchant_id: this.filter.merchant_id,
          payment_currency: this.filter.payment_currency,
          gx_platform: this.filter.gx_platform,
          order_number: this.filter.order_number,
          country_id: this.filter.country_id,
        })
        console.log(res.data)
        const {
          average_basket_amount,
          average_basket_size,
          top_store_name,
          top_store_sales,
          total_orders,
          total_products,
          total_products_amount,
          total_refunded_products_amount,
          total_refunded_shipping_amount,
          total_shipping_amount,
          } = res.data

          this.tableData[0].avgBasketAmount = average_basket_amount
          this.tableData[0].avgBasketSize = average_basket_size
          this.tableData[0].topStoreName = top_store_name
          this.tableData[0].topStoreSales = top_store_sales
          this.tableData[0].totalOrders = total_orders
          this.tableData[0].totalProducts = total_products
          this.tableData[0].totalProductsAmount = total_products_amount
          this.tableData[0].totalRefundProduct = total_refunded_products_amount
          this.tableData[0].totalRefundShipping = total_refunded_shipping_amount
          this.tableData[0].totalShipping = total_shipping_amount
      } catch (e) {
        console.log(e)
      } finally {
        this.isLoading = false
      }
    },
    handleSearch() {
      this.getList()
    },
    resetFiliter() {
      this.filter =  {
        platform: '',
        start_date: '',
        end_date: '',
        payment_currency: '',
        gx_platform: '',
        order_number: '',
        country_id: '',
        merchant_id: '',
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/view-base.scss";
@import "~@/assets/styles/table.scss";

.filter-container {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  flex-grow: 1;
  .filter-title {
    font-size: 13px;
    margin-right: 5px;
  }
}

section {
  .filter-item {
    margin: 3px 0;
    width: 100%;
    @include mobile {
      margin: 3px 5px;
      width: calc(100% / 3 - 10px);
    }
    @include tablet {
      width: calc(100% / 4 - 10px);
    }
    @include desktop {
      width: calc(100% / 6 - 10px);
    }
  }
  .data-picker-container {
    position: relative;
    // Make the hack button span the whole parent container.
    .absolute-view {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      opacity: 0;
    }
  }
}

.data-picker-container {
  width: 200px;
}

::v-deep {
  .el-table__row {
    .cell {
      a {
        text-decoration: underline;
      }
    }
  }
}

</style>
